/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Period_LabelInputs */

const vi_my_grower_report_period_label = /** @type {(inputs: My_Grower_Report_Period_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem theo`)
};

/**

* @param {My_Grower_Report_Period_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_period_label = /** @type {((inputs?: My_Grower_Report_Period_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Period_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_period_label(inputs)
});